<div class="p-grid p-fluid">
  <p-panel
    [toggleable]="true"
    *ngIf="autocolor"
    toggler="header"
    class="p-col-12 p-md-12"
  >
    <ng-template pTemplate="header">
      <b> {{ autocolor.nombre }} - {{ autocolor.fabricante.nombre }}</b>
    </ng-template>

    <div class="p-fluid p-grid">
      <div class="p-field p-col-6 p-md-3 m-0 py-0">
        <p><b> Código:</b> {{ autocolor.codigo }}</p>
      </div>
      <div class="p-field p-col-6 p-md-3 m-0 py-0">
        <p><b> Tipo:</b> {{ autocolor.tipo?.nombre }}</p>
      </div>
    </div>
  </p-panel>
</div>

<h4>Formulas</h4>
<div *ngIf="formula && !subformulas?.length" class="p-grid p-fluid">
  <br />
  <br />
  <formula-child [formulaChild]="formula" class="p-col-12 p-md-10">
  </formula-child>
</div>

<div *ngIf="subformulas" class="p-grid p-fluid">
  <formula-child
    *ngFor="let form of subformulas"
    [formulaChild]="form"
    class="p-col-12 p-md-10"
  >
  </formula-child>
</div>

<!-- <div class="p-grid p-fluid">
  <div class="p-field p-col-12 p-md-2">
    <p-button
      (click)="downloadFile()"
      class="vtn btn-secondary"
      label="Imprimir"
      icon="pi pi-print"
      iconPos="right"
    ></p-button>
  </div>
</div> -->
